module.exports = __webpack_public_path__ + "static/media/illustration-deep-breathing.60a5cf49.svg";